<template>
    <form @submit.prevent="handleFormSubmit" class="bg-white rounded-tl-xl rounded-tr-xl px-6 py-4">
        <TsRow append-class="flex-col m-0">
            <TsIcon :data-testid="'username-icon' + randomId" name="bitcoin-icons:cross-filled" size="24"
                @click="emit('close')"
                class="absolute top-5 right-4 text-idle-black hover:bg-info/10 rounded transition-colors cursor-pointer" />
            <TsTypography append-class="text-idle-black font-bold text-xl">
                {{useTranslation('AccountProfile-changeUsername','Gebruikersnaam wijzigen')}}
            </TsTypography>
            <TsDivider />
            <TsTypography append-class="">
                {{useTranslation('AccountProfile-chooseAnEmailAddress','Kies een e-mailadres als gebruikersnaam')}}
            </TsTypography>
        </TsRow>

        <TsRow append-class="flex-col my-2">
            <TsColumn class="is-12">
                <TsLabel :data-testid="'new-username-label-' + randomId" floating :label="useTranslation('AccountProfile-enterNewUsername','Entrez un nouveau nom d\'utilisateur*')"
                    :input-value="accountStore.profile_edit_user_name" append-class="bg-white">
                    <TsInput :data-testid="'new-username-' + randomId" required
                        v-model="accountStore.profile_edit_user_name" :id="'new-username-' + randomId" />
                </TsLabel>
            </TsColumn>
            <TsColumn class="is-12">
                <TsLabel floating :label="useTranslation('Account-confirmNewUsername','Bevestig nieuwe gebruikersnaam*')" :data-testid="'new-confirm-username-label-' + randomId"
                    :input-value="accountStore.profile_edit_confirm_user_name" append-class="bg-white">
                    <TsInput required v-model="accountStore.profile_edit_confirm_user_name"
                        :data-testid="'new-confirm-username-' + randomId" :id="'new-confirm-username-' + randomId" />
                </TsLabel>
            </TsColumn>
            <TsColumn class="is-12">
                <TsCheckbox :data-testid="'communication-email-' + randomId" :label="useTranslation('AccountProfile-updateCommunicationEmail','Communicatie-e-mail bijwerken')"
                    value="email" v-model="accountStore.profile_edit_update_email" :checked="true" />
            </TsColumn>
        </TsRow>

        <TsRow append-class="m-0 gap-1">
            <TsColumn append-class="px-0">
                <TsButton :data-testid="'submit-btn-' + randomId" v-if="!accountStore.loading" type="submit" block
                          :label="useTranslation('save','Redden')" size="sm" />
                <TsButton :data-testid="'submit-loader-btn-' + randomId" v-if="accountStore.loading" type="submit" block
                    size="sm">
                    <TsIcon class="animate-spin" name="mingcute:loading-line" size="24" />
                </TsButton>
            </TsColumn>
        </TsRow>
    </form>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { toast } from "vue3-toastify";

const TsCheckbox = defineAsyncComponent(
    () => import('~/components/atoms/TsCheckbox.vue')
);

const authStore = useAuthStore();
const accountStore = useAccountStore();
const customer_id = authStore?.user?.id;
const name = computed(() => accountStore?.profile?.username);
const email = computed(() => accountStore?.profile?.email);

const emit = defineEmits<{
    close: any;
}>();

// random ID for each Form Field
const randomId = ref("");

onMounted(() => {
    randomId.value = useRandomUUID();
});

const validateUsername = (username: string, confirmUsername: string) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

    if (!username) {
        return { valid: false, message: 'Username is required.' };
    }

    if (!username.match(emailRegex)) {
        return { valid: false, message: 'Please enter a valid email address.' };
    }

    if (username !== confirmUsername) {
        return { valid: false, message: 'Usernames do not match.' };
    }

    if (username === name.value && !accountStore.profile_edit_update_email) {
        return { valid: false, message: 'The username is already in use.' };
    }

    if (accountStore.profile_edit_update_email) {
        if (username === name.value) {
            return { valid: false, message: 'The username is already in use.' };
        }

        if (username === email.value) {
            return { valid: false, message: 'The Email is already in use.' };
        }
    }

    return { valid: true, message: 'Username is valid.' };
};

async function handleFormSubmit() {
    const error = validateUsername(accountStore.profile_edit_user_name, accountStore.profile_edit_confirm_user_name);

    if (error.valid) {
        await accountStore.updateUserName(accountStore.profile_edit_user_name, customer_id, accountStore.profile_edit_update_email);
    } else {
        toast(error.message, {
            autoClose: true,
            type: "error",
        });
        trackError("toast",error.message)
    }
}
</script>
